/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionDTO } from './QuestionDTO';
import {
    QuestionDTOFromJSON,
    QuestionDTOFromJSONTyped,
    QuestionDTOToJSON,
    QuestionDTOToJSONTyped,
} from './QuestionDTO';

/**
 * 
 * @export
 * @interface MeasurementDefinitionDTO
 */
export interface MeasurementDefinitionDTO {
    [key: string]: any | any;
    /**
     * 
     * @type {number}
     * @memberof MeasurementDefinitionDTO
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MeasurementDefinitionDTO
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeasurementDefinitionDTO
     */
    exampleRecording?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MeasurementDefinitionDTO
     */
    audioTrack?: string | null;
    /**
     * 
     * @type {Array<QuestionDTO>}
     * @memberof MeasurementDefinitionDTO
     */
    questions?: Array<QuestionDTO> | null;
}

/**
 * Check if a given object implements the MeasurementDefinitionDTO interface.
 */
export function instanceOfMeasurementDefinitionDTO(value: object): value is MeasurementDefinitionDTO {
    return true;
}

export function MeasurementDefinitionDTOFromJSON(json: any): MeasurementDefinitionDTO {
    return MeasurementDefinitionDTOFromJSONTyped(json, false);
}

export function MeasurementDefinitionDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MeasurementDefinitionDTO {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'exampleRecording': json['exampleRecording'] == null ? undefined : json['exampleRecording'],
        'audioTrack': json['audioTrack'] == null ? undefined : json['audioTrack'],
        'questions': json['questions'] == null ? undefined : ((json['questions'] as Array<any>).map(QuestionDTOFromJSON)),
    };
}

export function MeasurementDefinitionDTOToJSON(json: any): MeasurementDefinitionDTO {
    return MeasurementDefinitionDTOToJSONTyped(json, false);
}

export function MeasurementDefinitionDTOToJSONTyped(value?: MeasurementDefinitionDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'id': value['id'],
        'name': value['name'],
        'exampleRecording': value['exampleRecording'],
        'audioTrack': value['audioTrack'],
        'questions': value['questions'] == null ? undefined : ((value['questions'] as Array<any>).map(QuestionDTOToJSON)),
    };
}

